import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Typography } from '@dev/ee-components';
import { SplitOptimization } from '@dev/ee-api/ee-api-models';
import { map } from 'lodash-es';

import { getTimeInUnits } from '@/services/tools/getTimeInUnits';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { useGetSummaryData } from '@/components/CampaignCreator/hooks/useGetSummaryData';
import { VersionsSummary } from './components/Versions';
import { WinnerSummary } from './components/Winner';

const VersionsSummaryWrapper = styled.div`
    margin: 22px 0 32px;
`;

export const ABReadyToSection = (): JSX.Element => {
    const { t } = useTranslation();
    const { campaign } = useSelector(getCampainCreatorStore);
    const summaryData = useGetSummaryData();
    const wayToChooseWinner =
        campaign.SplitOptions.SplitOptimization === SplitOptimization.Opened
            ? t('opens').toLocaleLowerCase()
            : t('clicks').toLocaleLowerCase();
    const timeObj = getTimeInUnits(campaign.SplitOptions.DetermineWinnerAfterXMinutes);
    const winnerDesc = `${t('winnerdetermined')} ${wayToChooseWinner} ${t('after')} ${timeObj.value} ${
        timeObj.unit
    }, ${t('winningsent')}:`;

    const mappedABSummary = (isWinnerSection): JSX.Element[] =>
        map(summaryData, (item) => {
            const { alphabetSignature, uniqueRecipients, uniqueRecipientsPercent, isWinner } = item;

            if (isWinnerSection) {
                if (!isWinner) return;
                return (
                    <WinnerSummary
                        uniqueRecipients={uniqueRecipients}
                        uniqueRecipientsPercent={uniqueRecipientsPercent}
                    />
                );
            } else {
                if (isWinner) return;
                return (
                    <VersionsSummary
                        alphabetSignature={alphabetSignature}
                        uniqueRecipients={uniqueRecipients}
                        uniqueRecipientsPercent={uniqueRecipientsPercent}
                    />
                );
            }
        });

    return (
        <>
            <Typography variant="h3">{t('campaignwillbesent')}</Typography>
            <VersionsSummaryWrapper>{mappedABSummary(false)}</VersionsSummaryWrapper>
            <Typography variant="h3">{winnerDesc}</Typography>
            <VersionsSummaryWrapper>{mappedABSummary(true)}</VersionsSummaryWrapper>
        </>
    );
};
